// extracted by mini-css-extract-plugin
export var actionButton = "_m0-0";
export var actionMenuContainer = "_m0-i";
export var bubble = "_m0-2";
export var bubbleActionMenu = "_m0-j";
export var bubbleContext = "_m0-6";
export var bubbleItems = "_m0-7";
export var customer = "_m0-3";
export var divider = "_m0-8";
export var fileList = "_m0-9";
export var hiddenComment = "_m0-o";
export var infoAbove = "_m0-a";
export var internal = "_m0-4";
export var lightActionButton = "_m0-1";
export var link = "_m0-b";
export var merchant = "_m0-5";
export var message = "_m0-c";
export var profilePicture = "_m0-e";
export var quillToolbarContainer = "_m0-f";
export var senderDate = "_m0-g";
export var senderDateCustomer = "_m0-h";
export var senderName = "_m0-d";
export var time = "_m0-k";
export var uploadedImage = "_m0-l";
export var username = "_m0-m";
export var xsmall = "_m0-n";